<template>
  <div id="app">
    <router-view v-if="isLogin || $route.path == '/login' || $route.path == '/sign' || $route.path == '/reset'" />
    <el-container v-else class="outer">
      <el-aside width="244px">
        <el-menu :default-active="$route.path" :unique-opened="true" active-text-color="#FED400" background-color="#333333" class="left-bar" router text-color="#ffffff">
          <div class="logo"><img alt="" src="../src/assets/img/base/logo.png"></div>
          <el-menu-item :index="item.url" v-for="item in asideBarList[member.member_type]">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="page-header" height="56px">
          <div class="page-header-left" @click="goBack">
            <i v-if="breadBack" class="el-icon-arrow-left"></i>
            <div>{{ breadTxt }}</div>
          </div>
          <div class="page-header-right">
            <div class="right1 iconfont icon-xiaoxi" @click="goNews">
              <div v-if="topBellRedDotShow" class="red-dot"></div>
            </div>
            <el-dropdown @command="userClick">
              <div class="right2">
                <img :src="member.head_pic" alt="">
                <div class="user-info">
                  <div class="user-info-name">{{ member.real_name }}</div>
                  <div class="user-info-tag">{{ memberTypeDict[member.member_type] ? (memberTypeDict[member.member_type] == '业务员' && member.is_salesman_manager ? '业务经理': memberTypeDict[member.member_type]) : '' }}</div>
                </div>
                <i class="iconfont icon-xialaanniu"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="data">个人资料</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </el-header>
        <el-main class="page-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { Logout } from "@/http/api";
import { asideBarList } from "@/assets/js/asideBarList.js";
export default {
  data() {
    return {
      member: {},
      isLogin: false,
      breadTxt: this.$route.name,
      asideBarList: asideBarList,
      breadBack: false,
      returnUrl: "",
      memberTypeDict: {
        0: "医生",
        1: "导师",
        2: "业务员",
        3: "客服",
        4: "技师",
        5: "供应商",
      },
    };
  },
  computed: {
    // 顶部铃铛显示小红点
    topBellRedDotShow() {
      return this.$store.state.topBellRedDotShow;
    },
  },
  watch: {
    $route(to) {
      if (to.path == "/login" || to.path == "/sign" || to.path == "/reset") {
        //登录页和注册页不需要菜单
        this.isLogin = true;
      } else {
        this.isLogin = false;
        console.log(this.$route.name);
        this.breadTxt = to.name;
        this.breadBack = false;
      }
    },
    "$store.state.breadOption": {
      handler: function (newVal) {
        this.breadTxt = newVal.name;
        this.breadBack = newVal.isBack;
        if (newVal.url) this.returnUrl = newVal.url;
        else this.returnUrl = "";
      },
    },
    "$store.state.member": {
      handler: function (newVal) {
        this.member = newVal;
      },
    },
  },
  mounted() {
    if (localStorage.getItem("member")) {
      this.member = JSON.parse(localStorage.getItem("member"));
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    goBack() {
      if (!this.breadBack) return false;
      if (this.returnUrl == "") this.$router.back();
      else this.$router.push(this.returnUrl);
    },
    goNews() {
      this.$router.push("/news_center");
    },
    userClick(type) {
      if (type == "logout") {
        this.$confirm("确定退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          Logout().then((res) => {
            localStorage.setItem('member', '')
            localStorage.setItem('token','')
            window.location.href = "/login";
          });
        });
      } else {
        this.$router.push("/user_center");
      }
    },
  },
};
</script>

<style >
@import "assets/iconfont/iconfont.css";
@import "assets/css/hoverStyle.css";
@import "assets/css/common.css";
</style>
